import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { get } from 'lodash'

import {
  isLoaded as isAuthLoaded,
  load as loadAuth
} from 'redux/modules/auth'
import config from 'config'

@withRouter
class RestrictedInner extends Component {
  componentWillMount() {
    this.checkAuthentication(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      this.checkAuthentication(nextProps)
    }
  }

  checkAuthentication(props) {
    const { history, store } = props

    function checkAuth() {
      const { auth: { user } } = store.getState()

      if (!get(user, 'access_token')) {
        // oops, not logged in, so can't be here!
        history.push(`${config.publicPath}/`)
      }
    }

    if (!isAuthLoaded(store.getState())) {
      this.props.store.dispatch(loadAuth())
        .then(checkAuth)
    } else {
      checkAuth()
    }
  }

  render() {
    const { children } = this.props
    return (
      <React.Fragment>
        {children}
      </React.Fragment>
    )
  }
}

export default RestrictedInner
